import { Link } from "react-router-dom";
import { primeirasPalavras, getTitulo, getTexto } from "@/lib/salmos";
import { useLang } from "@/lib/i18n";

export default function SalmoCard({ salmo, indisponivel = false }) {
  const { lang, t } = useLang();

  if (indisponivel) {
    return (
      <div
        className="group relative rounded-sm border border-[var(--cor-borda)] bg-[var(--cor-fundo-2)]/40 p-7 opacity-50 cursor-not-allowed"
        data-testid={`salmo-card-indisponivel-${salmo.numero}`}
      >
        <div className="font-display text-5xl text-[var(--cor-texto-2)]/40">{salmo.numero}</div>
        <div className="mt-4 font-display uppercase tracking-[0.18em] text-[10px] text-[var(--cor-texto-2)]/60">{t.em_breve}</div>
      </div>
    );
  }

  const titulo = getTitulo(salmo, lang);
  const texto = getTexto(salmo, lang);

  return (
    <Link
      to={`/salmo/${salmo.numero}`}
      className="group relative block rounded-sm border border-[var(--cor-borda)] bg-[var(--cor-fundo-2)]/60 p-7 backdrop-blur-sm transition-all duration-500 hover:-translate-y-1 hover:border-[var(--cor-dourado)]/40 hover:shadow-[0_0_40px_rgba(201,169,110,0.12)]"
      data-testid={`salmo-card-${salmo.numero}`}
    >
      <div className="flex items-baseline justify-between mb-2">
        <div className="font-display text-5xl text-[var(--cor-dourado)] leading-none transition-colors group-hover:text-[var(--cor-dourado-claro)]">
          {salmo.numero}
        </div>
        <div className="font-display text-[10px] uppercase tracking-[0.22em] text-[var(--cor-texto-2)]">{t.salmo}</div>
      </div>
      <h3 className="font-display text-2xl text-[var(--cor-texto)] mt-4 leading-tight">{titulo}</h3>
      <p className="font-serif text-[var(--cor-texto-2)] mt-3 leading-relaxed text-[15px]">
        {primeirasPalavras(texto, 18)}
      </p>
      {salmo.tags && salmo.tags.length > 0 && (
        <div className="mt-5 flex flex-wrap gap-2">
          {salmo.tags.slice(0, 3).map((tag) => (
            <span key={tag} className="font-display text-[10px] uppercase tracking-[0.18em] text-[var(--cor-dourado)]/80 border border-[var(--cor-borda)] px-2.5 py-1 rounded-full">
              {tag}
            </span>
          ))}
        </div>
      )}
      {salmo.destacado && (!salmo.tags || salmo.tags.length === 0) && null}
    </Link>
  );
}
